<ng-container [ngSwitch]="pattern">
  <ng-container *ngSwitchCase="'withAvatar'">
    <div class="" (click)="onClick()">
      <ng-container [ngTemplateOutlet]="input"></ng-container>
      @if(imageUrl$ | async){
      <img [src]="imageUrl$ | async" class="rounded-circle object-fit-cover cursor-pointer" [ngClass]="imgSizeCSS" />
      }@else {
      <!-- Not the theme's `blank.png` — that is a blue silhouette baked into
           pixels, so it stays blue no matter what a customer's primary colour
           is. This is an icon, coloured from the same brand token every other
           accent on the page reads from. Circular, like every other avatar on
           the site (`symbol-circle`) — a person's photo, not a document. -->
      <div class="upload-image__placeholder rounded-circle d-flex align-items-center justify-content-center cursor-pointer"
        [ngClass]="imgSizeCSS">
        <app-keenicon name="user" class="upload-image__placeholder-icon fs-3hx text-primary"></app-keenicon>
      </div>
      }
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'withName'">
    <ng-container [ngTemplateOutlet]="input"></ng-container>
    <div class="preview" (click)="onClick()">
      <div class="btn select-image" [ngClass]="{ invalid: isError }">
        เลือกไฟล์รูปภาพ
      </div>
    </div>
    <div class="image-name">
      <app-keenicon class="fs-1" name="paper-clip"></app-keenicon>
      {{ imageName$ | async }}
    </div>
    <div class="invalid-feedback">{{ errorMessage | translate }}</div>
  </ng-container>

  <!-- <ng-container *ngSwitchCase="'withSign'">
    <div class="preview" (click)="onClick()">
      <ng-container [ngTemplateOutlet]="input"></ng-container>
      <img [src]="imageUrl$ | async" class="img-responsive img-fit-cover" *ngIf="imageUrl$ | async" />
      <div *ngIf="!(imageUrl$ | async)">
        <div>
          <ii-feather class="la la-cloud-upload"></ii-feather>
        </div>
        <div>
          {{ "Upload image" }}
        </div>
      </div>
    </div>
    <span *ngIf="(imageUrl$ | async) && removable" class="remove-image-icon" (click)="removeImage()">
      <i-feather class="fa fa-times-circle text-danger"></i-feather>
    </span>
  </ng-container> -->
</ng-container>

<ng-template #input>
  <input #imageInput id="image-input" type="file" name="image" accept="image/*" [hidden]="true"
    (change)="processFile(imageInput)" />
</ng-template>